import { Hero } from "./Hero";
import { HowItWorks } from "./HowItWorks";
import { WhatCanIDeploy } from "./WhatCanIDeploy";
import { FAQ2 } from "./FAQ2";
import { FinalCta } from "./FinalCta";
import { Templates2 } from "@/components/landing2/Templates2";

type Punchline = {
  pre: string;
  post: string;
  sub: string;
};

const PUNCHLINES: Punchline[] = [
  {
    pre: "You built",
    post: "Now ship it to real users.",
    sub: "Tell us what you want to build. We'll deploy it to a server you own - no DevOps knowledge required."
  },
  {
    pre: "You made",
    post: "We'll put it in production.",
    sub: "Drop your GitHub repo. We provision the server, configure HTTPS and deploy - then keep it running, so you stay focused on building."
  },
  {
    pre: "You built",
    post: "Let's give it a real URL.",
    sub: "From GitHub to a live production URL in minutes. Predictable monthly cost, a server you own, and no vendor lock-in."
  },
  {
    pre: "You shipped",
    post: "Now run it in production.",
    sub: "Built with Cursor, Claude, Lovable or Bolt? Connect your repo and we'll handle deployment, scaling and uptime for you."
  }
];

export const LandingPage2 = ({ punchlineIndex = 0 }: { punchlineIndex?: number }) => {
  const punchline = PUNCHLINES[punchlineIndex % PUNCHLINES.length];

  return (
    <div className="font-sans text-base leading-normal text-foreground bg-background antialiased relative min-h-screen">
      <Hero punchline={punchline} />
      <HowItWorks />
      <WhatCanIDeploy />
      <Templates2 />
      <FAQ2 landing />
      <FinalCta />
    </div>
  );
};
